import React, { useEffect } from "react";
import { Box, Stack, Chip, Button, IconButton, Grid, Typography, useTheme, Tooltip, TextField, FormGroup, FormControlLabel, Switch } from "@mui/material";
import Divider from '@mui/material/Divider';
import { useQuery } from "@tanstack/react-query";
//Hooks
import { getReturns } from "../../hooks/returns.jsx";
import { getManufacturers } from "../../hooks/manufacturers.jsx";



//Controls
import Controls from "../../components/controls/Contols";

//Icons
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import ReorderOutlinedIcon from '@mui/icons-material/ReorderOutlined';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
//Components
// import BookingInformation from "./components/BookingInformation";
// import PickupDetails from "./components/PickupDetails";
// import OrderList from "./components/OrderList";
import DrumList from "./components/DrumList";
import Ocr from "./components/ocr.jsx";

import { styled } from '@mui/material/styles';
import { tokens } from "../../assets/theme";
import { useState } from "react";
import dayjs from "dayjs";

// import { getAllActivities, getRecurringSchedules } from "./hooks/fetchers";
// import messages from "./components/messages";
// import { FormattedMessage } from "react-intl";

const OcrIndex = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    const returnsQuery = useQuery(
        ["returns"],
        () => getReturns(),
        {}
    );

    const manufacturersQuery = useQuery(
        ["manufacturers"],
        () => getManufacturers(),
        {}
    );

    // const drumsQuery = useQuery(
    //     ["drums"],
    //     () => getDrums(),
    //     {}
    // );

    const states = [1, 2, 3, 4, 9];
    const stateNames = ["Regitered", "In progress", "Pick up", "Paid", "Ready"];
    const statesCount = [];
    const [filteredData, setfilteredData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [showChildrenFor, setShowChildrenFor] = useState(0);
    const [showOrder, setShowOrder] = useState(null);
    const [slim, toggleSlim] = useState(false);
    const [sortBy, setSortBy] = useState(null);
    const [distinctCustomers, setDistinctCustomers] = useState([]);
    const [distinctTransporters, setDistinctTransporters] = useState([]);
    const [distinctReturnpoints, setDistinctReturnpoints] = useState([]);
    const [customerFilter, setCustomerFilter] = useState("");
    const [transporterFilter, setTransporterFilter] = useState("");
    const [returnpointFilter, setReturnpointFilter] = useState("");
    const [showHidden, setShowHidden] = useState(false);








    const handlePhotoSearch = (retId) => {
        console.log("Photo search", retId);

        //let result = returnsQuery.data?.filter(x => x.returnid === retId);
        let result = returnsQuery.data?.filter(x => x.returnid.toString() === retId.toString())[0];


        console.log("returnsQuery.data", returnsQuery.data);
        console.log("ocr index Result", result);

        setShowOrder(result);

        setfilteredData(result);

        //doFilter(stateValue, value, "", "", "");
    }


    if (returnsQuery.isLoading) {
        // return <Box color="white">Loading Return orders...<img src="../../../assets/axion_spinner2.gif" alt="ddd"></img></Box>;
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><img width="50px" height="50px" src="../../../assets/axion_spinner2.gif" alt="ddd"></img></div>;
    }
    if (manufacturersQuery.isLoading) {
        // return <Box color="white">Loading Manufacturers...<img src="../../../assets/axion_spinner2.gif" alt="ddd"></img></Box>;
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><img src="../../../assets/axion_spinner2.gif" alt="ddd"></img></div>;
    }
    // if (drumsQuery.isLoading) {
    //     // return <Box color="white">Loading Manufacturers...<img src="../../../assets/axion_spinner2.gif" alt="ddd"></img></Box>;
    //     return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><img src="../../../assets/axion_spinner2.gif" alt="ddd"></img></div>;
    // }

    // if (drumsQuery.isLoading) {
    //     // return <Box color="white">Loading Drums...<img src="../../../assets/axion_spinner2.gif" alt="ddd"></img></Box>;
    //     return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><img src="../../../assets/axion_spinner2.gif" alt="ddd"></img></div>;
    // }




    //setfilteredData(returnsQuery.data?.filter(x => x.statusid === 2));

    states.forEach((status) => {
        statesCount.push(returnsQuery.data?.filter(x => x.statusid === status).length)
    })


    //console.log("Returns", returnsQuery.data?.filter(x => x.statusid === 2));

    //console.log("filtered data", filteredData);
   // console.log("Drums:", drumsQuery.data);

    let content = <>


        <Box display="flex" width="100%" justifyContent="center">
            {/* <Ocr handlePhotoSearch={handlePhotoSearch}/> */}
            <Ocr handlePhotoSearch={handlePhotoSearch} />

        </Box>
        <Grid item xs={12}>
            <Box backgroundColor={colors.primary[400]} padding="10px">
                <DrumList data={showOrder} manufacturers={manufacturersQuery.data} />
            </Box>
        </Grid>

    </>;

    return (
        <>
            {content}
        </>
    )
};

export default OcrIndex;

